import { FC, ReactElement } from 'react';

export interface InfoBoxProps {
  message: string;
  onClick: () => void;
  buttonText: string;
}

const InfoBox: FC<InfoBoxProps> = ({ message, onClick, buttonText }): ReactElement => {
  return (
    <div className="tw-pointer-events-none tw-absolute tw-left-0 tw-right-0 tw-top-5 tw-z-10 tw-flex tw-justify-center md:tw-right-5 md:tw-top-16 md:tw-justify-end lg:tw-right-48 lg:tw-top-5">
      <div className="tw-inline-flex tw-gap-4 tw-rounded-md tw-border tw-border-raa-gray-3 tw-bg-raa-white tw-p-4">
        <p>{message}</p>
        <button
          className="raa-button-focus tw-pointer-events-auto tw-px-4 tw-uppercase tw-text-raa-orange"
          onClick={onClick}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default InfoBox;
